import { Box, Button, VStack, Heading, Span,Text } from '@bpba/ui-components';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom' ;
import { SubmitHandler, useForm } from "react-hook-form";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Localidad } from '../rest/models/Localidad';
import { Sucursal } from '../rest/models/Sucursal';
import { Queries } from '../rest/Queries';
import { useMutation, useQuery } from '@apollo/client';
import { getLocalidadesCDNI } from '../rest/queries/getLocalidadesCDNI';
import { getLocalidadesSuc } from '../rest/queries/getLocalidadesSuc';
import { getSucursales } from '../rest/queries/getSucursales';
import { Mutations } from '../rest/Mutations';
import { getPartidosSuc } from '../rest/queries/getPartidosSuc';
import { Partido } from '../rest/models/Partido';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { Result } from './Result';
import { ResultExito } from './ResultExito';
import { ResultError } from './ResultError';
import { postPrestamoPersonalSP } from '../rest/mutations/postPrestamoPersonalSP';
import { PrestamoPersonalSPApiRQ } from '../rest/models/PrestamoPersonalSPApiRQ';
import { PrestamoPersonalSP } from '../rest/models/PrestamoPersonalSP';
import { PRESTAMOPERSONAL_BANNER } from '../Constantes';

export const ComponentePrestamoPersonalSP: React.FC = () => {

    const { register, handleSubmit, resetField, formState: { errors }, reset } = useForm<PrestamoPersonalSP>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""

        }
    });



    const REQUIRED_FIELD = "Campo requerido.";
    const numberValidator = /^\d+$/;
    //eslint-disable-next-line
    const mailValidator = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const [idProvinciaCDNI, setIdProvinciaCDNI] = useState<string>();
    const [idProvinciaSuc, setIdProvinciaSuc] = useState<string>();
    const [idLocalidadSuc, setIdLocalidadSuc] = useState<string>();
    const [idPartidoSuc, setIdPartidoSuc] = useState<string>();
    const { data: { localidades } = {} } = useQuery<Queries>(getLocalidadesCDNI, { variables: { idProvincia: idProvinciaCDNI }, skip: !idProvinciaCDNI });
    const { data: { localidadesSuc } = {} } = useQuery<Queries>(getLocalidadesSuc, { variables: { idPartido: idPartidoSuc }, skip: !idPartidoSuc });
    const { data: { partidosSuc } = {} } = useQuery<Queries>(getPartidosSuc, { variables: { idProvincia: idProvinciaSuc }, skip: !idProvinciaSuc });
    const { data: { sucursales } = {} } = useQuery<Queries>(getSucursales, { variables: { idLocalidadSuc: idLocalidadSuc, filterBranch: 1 }, skip: !idLocalidadSuc });
    const [nroSolicitud, setNroSolicitud] = useState(0);
    const [adjuntar, setAdjuntar] = useState(false);

    const [postPrestamoPersonalAPI, { loading: loadingMutation }] = useMutation<Mutations>(postPrestamoPersonalSP);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<string>("");

    const [servicioOk, setServicioOk] = useState<boolean>(false);


    let search = window.location.search;
    let params = new URLSearchParams(search);
    let origenSolicitud = params.get('origenSolicitud');
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();


    function BuscLoc(formId: string) {
        setIdProvinciaCDNI(formId.split('-')[0]);

    }
    function BuscPartidosSuc(formId: string) {
        setIdProvinciaSuc(formId.split('-')[0]);
        setIdPartidoSuc('');
        setIdLocalidadSuc('');
        resetField('localidadSuc');
        resetField('sucursal');
    }
    function BuscLocSuc(formId: string) {
        setIdPartidoSuc(formId.split('-')[0]);
        if (formId === '') {
            setIdLocalidadSuc('');

        }
        resetField('localidadSuc');
        resetField('sucursal');
    }

    function BuscSuc(formId: string) {
        setIdLocalidadSuc(formId.split('-')[0]);
        resetField('sucursal');
    }


    const onSubmit: SubmitHandler<PrestamoPersonalSP> = async (data: PrestamoPersonalSP) => {
	if (data.tipoIngreso === "6") {
            setServicioOk(true);
            setMensajeRtaServicio("no puede acceder al producto");
        } else {
        const token = executeRecaptcha && (await executeRecaptcha('PrestamoPersonal'));
        let datos: PrestamoPersonalSPApiRQ = {
            "googleToken": token,
            "razonSocial": data.nombreyApellido,
            "cuit": data.cuit.toString(),
            "telefonoContacto": (data.telefonoArea + data.telefono).toString(),
            "localidad": data.provincia.split('-')[1] + "," + data.localidad + "," + data.calle + " " + data.numeroCalle + "," + data.piso,
            "email": data.email,
            "sucursal": Number(data.sucursal),
            "condicionImpositiva": data.tipoIngreso,
            "origenSolicitud": origenSolicitud === null ? "" : origenSolicitud

        };
        await postPrestamoPersonalAPI({ variables: { input: datos } }).then((response: any) => {
  
            if (response !== null || response !== undefined) {
                setServicioOk(true);
                if (response.data.PrestamoPersonalSPApiRQ.resultado === "ok") {
                    setNroSolicitud(response.data.PrestamoPersonalSPApiRQ.nroSolicitud);
                    setMensajeRtaServicio("Solicitud creada con éxito. En los próximos días nos contactaremos con vos.");
                    setAdjuntar(true);
                   
                } else if (response.data.PrestamoPersonalSPApiRQ.error.toUpperCase().includes("ya tiene una solicitud".toUpperCase())) {
                    
                    setMensajeRtaServicio(response.data.PrestamoPersonalSPApiRQ.error);
                  

                } else {
                    setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
                 

                }
            } else {
                setMensajeRtaServicio("Ha ocurrido un problema, inténtelo mas tarde.");
            

            }


        }).catch(() => {

            setServicioOk(false);
            setMensajeErrorPostProspecto("Ha ocurrido un problema, inténtelo mas tarde.");
        });

 }
    }
    const handleReset = () => {
        reset({});
        window.location.reload();
    };
    const handleRedirect = () => {
        navigate('/DocumentacionAdjunta', {
            state: {
                nroSolicitud:  nroSolicitud,
                banner: PRESTAMOPERSONAL_BANNER,
                titulo :"Préstamo Personal"
            }
        });
    };
    if (loadingMutation) return <SpinnerCajas />;
    if (adjuntar) return (
        <VStack>
            
            <VStack mt={"20px"}>
                        <Text fontSize={"22px"} lineHeight={"27px"} fontWeight={"400"} color={"primary.0"}>{mensajeRtaServicio}</Text>            
                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <Button
                                    onClick={() => handleReset()}
                                    variant="secondary"
                                    py={"10px !important"}
                                    style={{ width: "100%",
                                    height: "calc(1.8em + 0.75rem + 2px)"}}
                                >
                                    Finalizar
                                </Button>
                            </VStack>
                            <VStack mr={"0.5rem"}>
                            <Button
                                onClick={() => handleRedirect()}
                                variant="secondary"
                                py={"10px !important"}
                                style={{ width: "100%" ,backgroundColor:"white",
                                        borderRadius:"3px 8px 3px 8px",
                                        border:"solid 2px",borderColor:"#3c3c3b",
                                        color:"#3c3c3b",
                                        height: "calc(1.8em + 0.75rem + 2px)"}}
                            >
                                Adjuntar
                            </Button>
                            </VStack>
                        </VStack>
                    </VStack>
            
        </VStack>
    );
    if (servicioOk) return (
        <Result handleReset={handleReset}>
        <ResultExito message={mensajeRtaServicio}></ResultExito>
    </Result>
    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>

    );
    return (


        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>

                    <VStack mt={"20px"}>

                        <input {...register(`nombreyApellido`, { required: REQUIRED_FIELD, maxLength: 100 })} name='nombreyApellido' type={"text"} placeholder='Nombre y Apellido' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.nombreyApellido ? "* " + errors.nombreyApellido.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register(`cuit`, { required: REQUIRED_FIELD, minLength: { value: 11, message: "Debe tener al menos 11 dígitos" }, pattern: { value: numberValidator, message: "El campo debe ser numérico" } })} maxLength={11} name='cuit' placeholder='Cuit/Cuil' type={"text"} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.cuit ? "* " + errors.cuit.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input type={'text'} {...register("email", { required: REQUIRED_FIELD, maxLength: 100, pattern: { value: mailValidator, message: "Formato de email inválido ejemplo: juana@mail.com" } })} name="email" placeholder='Email' maxLength={100} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.email ? "* " + errors.email.message : ""}</Span>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Teléfono de contacto
                        </Span>
                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <input style={{ width: "100%" }} {...register("telefonoArea", { required: REQUIRED_FIELD, maxLength: 4, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefonoArea" placeholder='Área' maxLength={4} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefonoArea ? "* " + errors.telefonoArea.message : ""}</Span>
                            </VStack>
                            <VStack>
                                <input tabIndex={0} style={{ width: "100%" }} {...register("telefono", { required: REQUIRED_FIELD, maxLength: 14, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="telefono" placeholder='Número' maxLength={14} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.telefono ? "* " + errors.telefono.message : ""}</Span>
                            </VStack>
                        </VStack>
                    </VStack>

                    <VStack mt={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Localidad</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad"}
                                    style={{ width: "100%" }}
                                    {...register("provincia", { required: REQUIRED_FIELD })}
                                    onChange={(e: any) => BuscLoc(e.target.value)} name="provincia" placeholder='Provincia' >
                                    <option value="">Ubicación</option>
                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.provincia ? "* " + errors.provincia.message : ""}</Span>
                            </VStack>
                            <VStack >
                                <select tabIndex={0} aria-label={"Seleccione la localidad"} style={{ width: "100%" }} {...register("localidad", { required: REQUIRED_FIELD })} name="localidad" placeholder='Localidad' >
                                    <option value="" selected >Localidad/barrio</option>
                                    {localidades &&
                                        localidades.map((item: Localidad) =>
                                            <option value={item.desc_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.localidad ? "* " + errors.localidad.message : ""}</Span>
                            </VStack>
                        </VStack>


                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mt={"20px"} mr={"0.5rem"}>
                                <input tabIndex={0}{...register("calle", { required: REQUIRED_FIELD, maxLength: 50 })} name="calle" placeholder='Calle' maxLength={50} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.calle ? "* " + errors.calle.message : ""}</Span>
                            </VStack>
                            <VStack mt={"20px"} mr={"0.5rem"}>
                                <input tabIndex={0}{...register("numeroCalle", { required: REQUIRED_FIELD, maxLength: 5, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, })} name="numeroCalle" placeholder='Número' maxLength={5} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.numeroCalle ? "* " + errors.numeroCalle.message : ""}</Span>
                            </VStack>
                            <VStack mt={"20px"}>
                                <input tabIndex={0}{...register("piso", { required: false, maxLength: 8 })} name="piso" placeholder='Piso' maxLength={8} type={"text"} />
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.piso?.message}</Span>
                            </VStack>

                        </VStack>

                    </VStack>
                    <VStack mt={"20px"} mb={"20px"}>
                        <Span color="primary.0" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Por favor, seleccioná tu tipo de ingresos</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack>
                                <select tabIndex={0} aria-label={"Por favor, seleccioná tu tipo de ingreso"}
                                    style={{ width: "100%" }}
                                    {...register("tipoIngreso", { required: REQUIRED_FIELD })}
                                    name="tipoIngreso" placeholder='tipoIngreso' >
                                    <option value="">Seleccione datos tributarios</option>
                                    <option value="1">Relación de Dependencia</option>
                                    <option value="2">Monotributista</option>
                                    <option value="3">Responsable inscripto</option>
                                    <option value="5">Jubilado/a</option>
                                    <option value="6">No puedo demostrar ingresos</option>
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.tipoIngreso ? "* " + errors.tipoIngreso.message : ""}</Span>
                            </VStack>

                        </VStack>


                    </VStack>

                    <VStack mt={"20px"}>
                        <Span mb={"8px"} color="primary.0" fontSize={"14px"} style={{ lineHeight: "18px" }}>Sucursal donde querés finalizar el tramite</Span>

                        <VStack style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la provincia para la localidad de la  sucursal"}
                                    {...register("provinciaSuc", { required: REQUIRED_FIELD })}
                                    onChange={(e) => BuscPartidosSuc(e.target.value)} name="provinciaSuc">
                                    <option value="" >Ubicación</option>
                                    <option value="2-Buenos Aires">Buenos Aires</option>
                                    <option value="1-Ciudad de Buenos Aires">Ciudad de Buenos Aires</option>
                                </select>

                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.provinciaSuc ? "* " + errors.provinciaSuc.message : ""}
                                </Span>
                            </VStack>
                            <VStack>
                                <select tabIndex={0} aria-label={"Seleccione el partido de la  sucursal"} {...register("partidoSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscLocSuc(e.target.value)} name="partidoSuc"
                                >
                                    <option value="" >Partido</option>
                                    {partidosSuc &&
                                        partidosSuc.map((item: Partido) =>
                                            <option value={item.id_partido} key={item.desc_partido}>{item.desc_partido}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.partidoSuc ? "* " + errors.partidoSuc.message : ""}
                                </Span>
                            </VStack>
                        </VStack>
                        <VStack mt={"20px"} style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}>
                            <VStack mr={"0.5rem"}>
                                <select tabIndex={0} aria-label={"Seleccione la localidad de la  sucursal"} {...register("localidadSuc", { required: REQUIRED_FIELD })} onChange={(e) => BuscSuc(e.target.value)} name="localidadSuc"
                                >
                                    <option value="" >Localidad/barrio</option>
                                    {localidadesSuc &&
                                        localidadesSuc.map((item: Localidad) =>
                                            <option value={item.id_localidad} key={item.desc_localidad}>{item.desc_localidad}</option>
                                        )}
                                </select>

                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.localidadSuc ? "* " + errors.localidadSuc.message : ""}
                                </Span>
                            </VStack>
                            <VStack>
                                <select tabIndex={0} aria-label={"Seleccione la  sucursal"} style={{ width: "100%" }} {...register("sucursal", { required: REQUIRED_FIELD })} name="sucursal" >
                                    <option value="" disabled>Sucursal</option>
                                    {sucursales &&
                                        sucursales.map((item: Sucursal) =>
                                            <option value={item.cod_ubic} key={item.suc_nombre}>{item.cod_ubic + " - " + item.suc_nombre}</option>
                                        )}
                                </select>
                                <Span color="red" fontSize={"12px"} tabIndex={0}>
                                    {errors.sucursal ? "* " + errors.sucursal.message : ""}
                                </Span>
                            </VStack>
                        </VStack>




                    </VStack>

                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>


                </form>
            </VStack>

        </Box>

    )

};


